export default function startsWithNumber(value) {
    return /^\d/.test(value);
}